import { SupportCenter } from '@/features/shared/support/SupportCenter';

/** Owner → OJP support (tickets + live chat). The same center is used by the desk officer and bursar. */
export function SupportPage() {
  return <SupportCenter />;
}
